<div class="self-disclosure-child-list__content">
  <form [formGroup]="form()">
    <span>{{ selfDisclosureQuestion.title | translate }}</span>
    @if (selfDisclosureQuestion.mandatory) {
      <span class="required-marker ng-star-inserted">&nbsp;*</span>
    }
    @for (person of getFormControls; track person; let i = $index) {
      <div class="mb20">
        <app-self-disclosure-child
          [form]="person"
          [title]="
            ('self_disclosure.answer.child_list_subheader' | translate) +
            ' ' +
            (i + 1)
          "
          [selfDisclosureQuestion]="selfDisclosureQuestion"
          [showRemove]="true"
          [showBirthdate]="showBirthdate()"
          (onRemove)="removeChild(i)"
        ></app-self-disclosure-child>
      </div>
    }

    <div class="row mt20 self-disclosure-child-list__choices">
      @if (selfDisclosureQuestion.mandatory && !getFormControls.length) {
        <div class="col justify-content-center">
          <label class="im:checkbox-label">
            <input
              class="im:checkbox-input"
              type="checkbox"
              formControlName="answerUnavailable"
            />
            <span class="im:body">{{ 'general.no_l' | translate }}</span>
          </label>
        </div>
      }
      <div class="col">
        <button
          im-button
          class="primary"
          [disabled]="selfDisclosureQuestion.answerUnavailable"
          (click)="addChild()"
        >
          {{ 'self_disclosure.answers.add_person_a' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
